import { useNavigate } from 'react-router-dom';
import { getPrimaryImage } from '../../services/imageService';
import Image from '../common/Image';
import './BestSellerSection.css';

const BestSellerSection = ({ products = [] }) => {
  const navigate = useNavigate();

  const handleProductClick = slug => {
    navigate(`/products/${slug}`);
  };

  // Use actual products from API, limit to 3
  const displayProducts = products && products.length > 0 ? products.slice(0, 3) : [];

  // Don't render section if no products available
  if (displayProducts.length === 0) {
    return null;
  }

  // Background colors for each card (black, white, black)
  const cardBackgrounds = ['#000000', '#ffffff', '#000000'];

  return (
    <section className="bestseller-section">
      <div className="bestseller-container">
        <h2 className="bestseller-title" data-reveal-item>
          Discover Our Bestseller
        </h2>
        <div className="bestseller-grid">
          {displayProducts.map((product, index) => {
            const primaryImage = getPrimaryImage(product.images);

            return (
              <div
                key={product.id}
                className="bestseller-card"
                onClick={() => handleProductClick(product.slug)}
                data-reveal-item
                style={{ '--reveal-index': index + 1 }}
              >
                <div
                  className="bestseller-image-wrapper"
                  style={{ backgroundColor: cardBackgrounds[index] }}
                >
                  <Image
                    src={primaryImage?.image_url}
                    alt={product.name}
                    className="bestseller-image"
                    fallback="/placeholder-watch.jpg"
                  />
                </div>
                <h3 className="bestseller-product-name">
                  {product.name}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BestSellerSection;
